export { default as CardComponent } from "./CardComponent";
